const PERSIST_ROOT_KEY = 'persist:root';
const SIGN_IN_PATH = '/sign-in';

let unauthorizedRedirectInFlight = false;

export function clearPersistedAuthState(): void {
  if (globalThis.sessionStorage === undefined) {
    return;
  }

  globalThis.sessionStorage.removeItem(PERSIST_ROOT_KEY);
}

export function handleUnauthorizedSession(): void {
  clearPersistedAuthState();

  if (globalThis.location === undefined) {
    return;
  }

  if (
    unauthorizedRedirectInFlight ||
    globalThis.location.pathname.startsWith(SIGN_IN_PATH)
  ) {
    return;
  }

  unauthorizedRedirectInFlight = true;
  globalThis.location.replace(SIGN_IN_PATH);
}